import {AfterContentInit, Directive, ElementRef, HostListener, OnDestroy} from '@angular/core';
import {debounce} from "lodash";

@Directive({
  selector: '[brtPreviewBoxAlignment]'
})
export class PreviewBoxAlignmentDirective implements AfterContentInit, OnDestroy {

  private CSS_CLASS_NAME = ".preview-box";
  private setPreviewBoxesAlignmentsDebounced = debounce(() => {
    this.setPreviewBoxesAlignments();
  }, 200);

  tagsWrapperOrderSet = false;
  mutationObserver!: MutationObserver;
  constructor(private el: ElementRef) { }
  @HostListener("window:resize", ['$event']) onResize($event: Event) {
    this.setPreviewBoxesAlignmentsDebounced();
  }

  ngAfterContentInit() {
    this.setPreviewBoxesAlignments();

    this.mutationObserver = new MutationObserver((mutations, observer) => {
      for(const mutation of mutations) {
        if(mutation.type === "childList") {
          this.setPreviewBoxesAlignmentsDebounced();
        }
      }
    });


    this.mutationObserver.observe(this.el.nativeElement as Node, {childList: true, attributes: false, characterData: false, subtree: true});

  }

  setPreviewBoxesAlignments() {

    const startTime = Date.now();
    const mainContentEl = this.el.nativeElement as HTMLElement;
    const previewBoxes = mainContentEl.querySelectorAll(".preview-box");
    if(previewBoxes.length) {
      previewBoxes.forEach((el) => {
        const topEl = el.querySelector(".preview-box__top") as HTMLElement;
        topEl.style.height = "";
        const contentEl = el.querySelector(".preview-box__main-content") as HTMLElement;
        contentEl.style.height = "";

        // Experimental feature
        // if(!this.tagsWrapperOrderSet) {
        //   const tagsWrapper = el.querySelector(".preview-box__tags");
        //   if(tagsWrapper) {
        //     let tags: {width: number, element: Element}[] = [];
        //     tagsWrapper.querySelectorAll(".preview-box__tag").forEach((el) => {
        //       tags.push({element: el, width: el.clientWidth});
        //     });
        //
        //     tags.sort((a, b) => {
        //       return a.width < b.width ? 1 : -1;
        //     });
        //
        //     tags.forEach((el) => {
        //       tagsWrapper.prepend(el.element);
        //     });
        //
        //     const accordanceLevel = tagsWrapper.querySelector(".preview-box__accordance-level--mobile");
        //     if(accordanceLevel) {
        //       tagsWrapper.prepend(accordanceLevel);
        //     }
        //   }
        // }
        //
      });
      this.tagsWrapperOrderSet = true;
      const rowElements = new Map<number, {headlineElement: HTMLElement, headlineHeight: number, mainContentElement: HTMLElement, mainContentHeight: number}[]>();
      previewBoxes.forEach((el) => {
        const elBCRTop = el.getBoundingClientRect().top;
        const row = rowElements.get(elBCRTop) ?? [];
        const headlineElement = el.querySelector(".preview-box__top") as HTMLElement;
        const headlineHeight = headlineElement.clientHeight ?? 0;
        const mainContentElement = el.querySelector(".preview-box__main-content") as HTMLElement;
        const mainContentHeight = mainContentElement.clientHeight ?? 0;
        row.push({headlineElement, headlineHeight, mainContentElement, mainContentHeight });
        rowElements.set(elBCRTop, row);
      });

      rowElements.forEach((value, key, map) => {
        const highestHeadlineHeight = value.reduce((accumulator, currentValue) => accumulator < currentValue.headlineHeight ? currentValue.headlineHeight : accumulator,
          0);

        const highestContentHeight = value.reduce((accumulator, currentValue) => accumulator < currentValue.mainContentHeight ? currentValue.mainContentHeight : accumulator,
          0);

        value.map((el) => {
          el.headlineElement.style.height = `${highestHeadlineHeight}px`;
          el.mainContentElement.style.height = `${highestContentHeight}px`;
        })
      })

    }

    // console.log(`All this took ${Date.now() - startTime}ms`);
  }

  ngOnDestroy() {
    this.mutationObserver.disconnect();
  }

}
